import React from "react";
import {
  fetchCreateBusiness,
  fetchEditBusiness,
} from "../../../../api/business";
import { Form, Input, Modal, Select, message } from "antd";
import { Encrypt } from "../../../../utils/secret";
const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 36 },
    sm: { span: 18 },
  },
};
const { Option } = Select;
class EditEmployee extends React.Component {
  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        if (!this.props.businessInfo.companyId) {
          let data = Encrypt(
            JSON.stringify({
              ...values,
            })
          );
          fetchCreateBusiness(data).then((res) => {
            if (res.success) {
              message.success("添加成功");
              this.props.handleCancel();
              this.props.getBusinessList();
            }
          });
        } else {
          let data = Encrypt(
            JSON.stringify({
              ...values,
              companyId: this.props.businessInfo.companyId,
            })
          );
          fetchEditBusiness(data).then((res) => {
            if (res.success) {
              message.success("编辑成功");

              this.props.handleCancel();
              this.props.getBusinessList();
            }
          });
        }
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { visible, handleCancel, isAdd, businessInfo } = this.props;
    return (
      <Modal
        destroyOnClose={true}
        title={isAdd ? "添加商户" : "编辑商户"}
        visible={visible}
        onOk={this.handleOk}
        onCancel={handleCancel}
      >
        <Form onSubmit={this.handleOk} {...formItemLayout}>
          <Form.Item label="商户名称">
            {getFieldDecorator("companyName", {
              initialValue: businessInfo.companyName,
              rules: [{ required: true, message: "请输入商户名称" }],
            })(<Input placeholder="请输入商户名称" />)}
          </Form.Item>
          <Form.Item label="联系人">
            {getFieldDecorator("contacts", {
              initialValue: businessInfo.contacts,

              rules: [{ required: true, message: "请输入联系人" }],
            })(<Input placeholder="请输入联系人" />)}
          </Form.Item>
          <Form.Item label="联系方式">
            {getFieldDecorator("telephone", {
              initialValue: businessInfo.telephone,

              rules: [{ required: true, message: "请输入联系方式" }],
            })(<Input placeholder="请输入联系方式" />)}
          </Form.Item>
          <Form.Item label="登录账号">
            {getFieldDecorator("mobilePhone", {
              initialValue: businessInfo.mobilePhone,

              rules: [{ required: true, message: "请输入登录账号" }],
            })(<Input placeholder="请输入手机号码" />)}
            {isAdd ? (
              <span style={{ fontSize: 12, color: "rgba(0,0,0,0.45)" }}>
                初始密码为手机号码后六位
              </span>
            ) : null}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(EditEmployee);
